// extracted by mini-css-extract-plugin
module.exports = {"h1":"Heading_h1__gmtuq","h2":"Heading_h2__SfHe8","h3":"Heading_h3__E_9EN","h4":"Heading_h4__JLBM3","h5":"Heading_h5__sAztc","h6":"Heading_h6__DySTt"};